/*
* This script is used to handle the product grid view functionality
* It allows users to switch between grid and list views
* The script is responsible for:
*  setting the view mode based on user selection
*  storing the selected view mode in localStorage
*  applying the selected view mode on page load
*/
function ecostalProduct() {
  const viewWrapper = document.querySelector('.js-view');
  const viewButtonGrid = viewWrapper?.querySelector('.js-view-grid');
  const viewButtonSingle = viewWrapper?.querySelector('.js-view-single');
  const productGrid = document.querySelector('.js-product-grid');

  const SINGLE_VIEW = 'product-grid--single';
  const STORAGE_KEY = 'productGridView';

  /*
      For the two views Grid or List Check which one it is then set it active at the top
      Also update the localstorage for if the user leaves the page
      then after all is done set the product grid to opacity 1 so it is viewable
   */
  function setView(isSingleView) {
    if (productGrid && viewButtonSingle && viewButtonGrid) {
      productGrid.classList.toggle(SINGLE_VIEW, isSingleView);
      viewButtonSingle.classList.toggle('active', isSingleView);
      viewButtonGrid.classList.toggle('active', !isSingleView);
      localStorage.setItem(STORAGE_KEY, isSingleView ? SINGLE_VIEW : '');
      productGrid.classList.add('js-show');
    }
  }

  // Apply stored view mode on page load
  setView(localStorage.getItem(STORAGE_KEY) === SINGLE_VIEW);

  if (viewButtonSingle && viewButtonGrid) {
    viewButtonGrid.addEventListener('click', () => setView(false));
    viewButtonSingle.addEventListener('click', () => setView(true));
  }
}

ecostalProduct();

if (typeof observerGrid === 'undefined') {
  observerGrid = new MutationObserver(() => {
    ecostalProduct();
  });

  // Watch the grid
  const productGridContainer = document.querySelector(".product-grid-container");
  if (productGridContainer) {
    observerGrid.observe(productGridContainer, {
      childList: true,
      subtree: true
    });
  }
}

function centerSlider() {
  const title = document.querySelector('.js-slider-title');
  const offsetTarget = document.querySelector('.js-offset-left');

  if (!title || !offsetTarget) return;

  // Get the title's visual position relative to the viewport
  const titleLeft = title.getBoundingClientRect().left;

  // Apply that as padding-left to the target element
  offsetTarget.style.paddingLeft = `${titleLeft + 50}px`;
}

window.addEventListener('resize', debounce(() => {
  centerSlider();
}, 300));

centerSlider();



class productCard extends HTMLElement {
  constructor() {
    super();

    this.saveCartButton = this.querySelector('.js-save-cart-button');

    if (this.saveCartButton) {
      this.saveCartButton.addEventListener('click', (e) => {
        if (window.cartSaver) {
          const data = e.target.dataset;

          // Set the productCallback function
          window.cartSaver.productCallback = function () {
            return [
              {
                variant_id: data.variantId,
                quantity: 1,
                properties: null,
              },
            ];
          };

          // Open the modal
          window.cartSaver.openSelector();
        }
      });
    }
  }
}

customElements.define('product-card', productCard);


